import React from 'react'


const Spinner = () => {
  return (
    <div style={{
        textAlign:'center',
        
    }}>
        <img src='https://www.idpsgkp.com/img/processingN.gif' alt='loading'></img>
    </div>
  )
}

export default Spinner